import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { NCRSlot } from '../../builders/ap_generic_slot_builder';
import { APTerm } from '../../builders/ap_term_builder';
import { MarkAsMetFacade } from '../mark_as_met/facades/mark_as_met_facade';

interface ITermEntry {
  id: number;
  name: string;
}

class NcrController {
  private ncr: NCRSlot;
  private menuId: string;
  constructor(
    private saveCourseGroupToTermCommand: ICommand,
    private removeCourseGroupFromTermCommand: ICommand,
    private removeCourseGroupFromTermAndAddCourseGroupCommand: ICommand,
    private markAsMetFacade: MarkAsMetFacade,
    private ngAPTermsQuery: IQuery
  ) {}

  $onInit() {
    this.menuId = _4.uniqueId();
  }

  addPlaceholder(ncr: NCRSlot, term: ITermEntry) {
    this.saveCourseGroupToTermCommand({
      course_group: ncr.programSlot.course_group,
      term: term.id,
      program_slot: ncr.programSlot.id
    });
  }

  moveAction(ncr: NCRSlot, term: ITermEntry) {
    if (!_4.isEmpty(ncr.plannedCourseGroup)) {
      this.removeCourseGroupFromTermAndAddCourseGroupCommand(ncr.plannedCourseGroup, ncr.plannedCourseGroup, term.id);
    }
  }

  removeAction(ncr: NCRSlot) {
    this.removeCourseGroupFromTermCommand(ncr.programSlot, ncr.plannedCourseGroup.id);
  }

  termItemClick(term: APTerm) {
    this.ncr.isPlanned ? this.moveAction(this.ncr, term) : this.addPlaceholder(this.ncr, term);
  }
}

class NCRMenu implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      ncr: '<'
    };
    this.controller = NcrController;
    this.templateUrl = 'capability-ng-academic-planner/src/global/components/ncr_menu/ncr_menu.html';
  }
}

angular.module('capability-ng-academic-planner').component('ncrMenu', new NCRMenu());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/ncr_menu/ncr_menu.ts